import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class AuthFlowSetupService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'AuthFlowSetupService');
  }

  loadBean(actionCd: string, cmpId: number): Observable<any> {
    let serviceUrl =
      this.baseUrl + this.serviceName + '/edit?' + 'actionCd=' + actionCd + '&cmpId=' + cmpId;

    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  save(bean: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/update?';
    return this.request(serviceUrl, this.setPostParams(bean, {responseType: 'text'})).pipe(
      catchError(super.handleError),
    );
  }

  getAsyncCompanyVerifiers(cmpId: string): Observable<{id: string; text: string; extra?: any}[]> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getCompanyVerifiers?' + 'param1=' + cmpId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getAsyncCompanyApprovers(cmpId: string): Observable<{id: string; text: string; extra?: any}[]> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getCompanyApprovers?' + 'param1=' + cmpId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
}
